export default __webpack_public_path__ + "media/images/dashboard_icons/globe-d5580452ccd3fea7bd5c3e88f03f75c8.svg";